import { ReactNode } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useSession } from '../session';

const ROLE: Record<string, string> = { owner: 'tulajdonos', sales: 'értékesítő', support: 'ügyfélszolgálat', finance: 'pénzügy', admin: 'adminisztrátor' };

export function Layout({ children }: { children: ReactNode }) {
  const s = useSession();
  const nav = useNavigate();
  return (
    <div className="shell">
      <header className="top">
        <div className="brand">BrunoCRM</div>
        <nav>
          {s.on('ai.agents') && <NavLink to="/teendok">Teendők és jóváhagyások</NavLink>}
          <NavLink to="/feladatok">Feladatok</NavLink>
          <NavLink to="/ertekesites">Értékesítés</NavLink>
          <NavLink to="/ajanlatok">Ajánlatok</NavLink>
          {s.role !== 'support' && <NavLink to="/szamlak">Számlák</NavLink>}
          {s.role !== 'support' && <NavLink to="/riportok">Riportok</NavLink>}
          <NavLink to="/cegek">Cégek</NavLink>
          <NavLink to="/kontaktok">Kontaktok</NavLink>
          {(s.role === 'owner' || s.role === 'admin') && <NavLink to="/import">Import</NavLink>}
          {s.on('ai.agents') && <NavLink to="/ugynokok">Ügynökök</NavLink>}
        </nav>
        <div className="spacer" />
        {s.me!.memberships.length > 1 ? (
          <select aria-label="Saját cég" value={s.entityId ?? ''} onChange={(e) => { s.switchEntity(e.target.value); nav('/'); }}>
            {s.me!.memberships.map((m) => <option key={m.entity_id} value={m.entity_id}>{m.entity_name}</option>)}
          </select>
        ) : <span className="entity">{s.me!.memberships[0]?.entity_name}</span>}
        <NavLink to="/beallitasok/postafiok" className="small" title="Postafiók és naptár">Postafiók</NavLink>
        <span className="user" title={s.me!.user.email}>{s.me!.user.name}{s.role && <small> · {ROLE[s.role] ?? s.role}</small>}</span>
        <button className="link" onClick={() => s.logout()}>Kilépés</button>
      </header>
      <main>{children}</main>
    </div>
  );
}
